/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { AuthService } from '../services/auth.service';
import { GlobalMessageService } from '../services/global-message.service';
import { AlertDialogComponent } from '../global/alert-dialog/alert-dialog.component';

import { SentryService } from '../services/sentry.service';
import { DriftService } from '../services/drift.service';

import { Animations } from '../global/animations';
import { SocketService } from '../services/socket.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  animations: Animations.authForms
})
export class LoginComponent implements OnInit {

  @ViewChild('invalidGoogleDialog') invalidGoogleDialog: TemplateRef<any>;

  fpDialogRef: BsModalRef;
  invalidGoogleDialogRef: BsModalRef;

creds = {
  email: '',
  password: '',
  rememberMe: false
};

  validCreds: boolean = true;
  visible: string = 'off';
  googleEmailAddress: string = '';
  forgotEmail: string = '';

  holdLogin: boolean = false;

  constructor(private authService: AuthService,
              private router: Router,
              private globalMessageService: GlobalMessageService,
              private modalService: BsModalService,

              private driftService: DriftService,
              private sentryService: SentryService,
              private socketService: SocketService) {}

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.router.navigate(['']);
    }
    else {
      setTimeout(() => {
        this.visible = 'on';
      }, 10);
    }
  }

  changePassword() {
    this.validCreds = true;
  }

  onSubmit() {
    this.authService.login(this.creds.email.toLowerCase(), this.creds.password).subscribe(
      () => {
      this.visible = 'off';
      this.driftService.identify();

      this.sentryService.identify();

      this.driftService.track('logged-in', { type: 'email' });
      // socket-io
      this.socketService.connect();
    },
    (err) => {
      // invalid login or password
      if (err.status == 401) {
        this.validCreds = false;


        if (err.error.attempts == 3) {
          this.modalService.show(AlertDialogComponent, Object.assign({}, {
            initialState: {
              message: 'You have 3 failed login attempts. For security reasons, after 5 attempts you will be unable to log in for 30 minutes.<br/><br/>If you forgot your password, please use the "Forgot your password?" link and we will email you reset instructions.',
              confirmBtn: 'Close'
            }
          }));
        }

        if (err.error.attempts >= 5) {
          // track failed attempts and stop them at 5 for a 3 minute delay
          this.modalService.show(AlertDialogComponent, Object.assign({}, {
            initialState: {
              message: 'You have too many failed login attempts. For security reasons, you will be prevented from attempting to log in for 30 minutes.<br/><br/>If you forgot your password, please use the "Forgot your password?" link and we will email you reset instructions.',
              confirmBtn: 'Close'
            }
          }));
          this.holdLogin = true;
        }
      }
      else {
        // some other server error, needs to be logged
        this.globalMessageService.error();
        throw err;
      }
    });
  }

  forgotPasswordDialog(dialog) {
    this.fpDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  forgotPassword() {
    this.authService.pwReset(this.forgotEmail.toLowerCase()).subscribe(
      () => {
        this.driftService.track('reset-password');

        this.globalMessageService.message('Password reset email was sent');
      },
      (err) => {
        // pen remediation #4. Don't show an error when there is an error
        this.globalMessageService.message('Password reset email was sent');
        throw err;
      }
    );
    this.fpDialogRef.hide();
  }

  invalidGoogleLogin(emailAddress: string) {
    this.googleEmailAddress = emailAddress;
    this.invalidGoogleDialogRef = this.modalService.show(this.invalidGoogleDialog);
  }

}



// WEBPACK FOOTER //
// ./client/app/login/login.component.ts